import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const spireApi = createApi({
    reducerPath: 'spire',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://javascriptorian.com/',
    }),
    endpoints: (build) => ({
        getChoices: build.query({
            query: (data) => `R${data.resourceCount}-C${data.choiceOrder}.json`
        })
    })
});

export const {
    useLazyGetChoicesQuery
} = spireApi;
